import styled from 'styled-components';

export const MainDetailsSection = styled.div`
display: flex;
/* padding-top: var(--40px, 40px); */
align-items: flex-start;

@media screen and (max-width:768px) {
  padding: 0px;
}

`;
export const DetailsSection = styled.div`
  display: flex;
  margin-top: 40px;
  width: 716px;
  padding: 40px 0px 16px 0px;
  flex-direction: column;
  align-items: center;
  gap: 130px;
  align-self: stretch;
  border-radius: 40px 0px 0px 0px;
  background: var(--Greyscale-WHITE, #FFF);
  right: 0;
  position: absolute;
  height: 104vh;
  overflow: auto;
  justify-content: ${(props) => props.children[1]?.props?.currentPage === 'REGISTER' ? 'unset' : 'center'};

  @-moz-document url-prefix() {
    margin-top: ${(props) => (props.currentPage === 'REGISTER' && props.regSecondPhase) && '20px'};
    height: ${(props) => (props.currentPage === 'REGISTER' && props.regSecondPhase) && '128.7vh'};;
  }

  @media screen and (max-width:768px) {
    width: 100%;
    border-radius: 0px;
    scrollbar-width: none;
    height: 100%;
    margin-top: 0;
  }

  @media screen and (min-width: 1440px) {
    /* width: 45%; */
  }
`;


export const LogoSection = styled.div`
display: flex;
width: calc(100% - 712px);
height: calc(100% - 40px);
position: absolute;
background: #222739;

flex-direction: column;
justify-content: center;
align-items: center;
gap: 10px;
align-self: stretch;

@media screen and (max-width:768px) {
  display: none;
}
`;

export const LogoContent = styled.article`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 16px;
`;